import React from "react";
import { FormMessage } from "../../components/shared/form-message";
import { useId } from "../../hooks/use-id";
import { DocumentType } from "../DocumentType";

/**
 * Campo de selección del tipo de documento de identificación.
 *
 * Renderiza un listado desplegable con los tipos de documento disponibles,
 * registra el campo en React Hook Form y valida que el usuario seleccione
 * una opción antes de enviar el formulario. Cuando la validación falla,
 * muestra el mensaje de error correspondiente.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.formController - Instancia de React Hook Form utilizada para registrar y validar el campo.
 * @param {Object} props.texts - Objeto con los textos traducidos utilizados en la interfaz.
 *
 * @returns {JSX.Element} InstIdTypeField
 */
export const InstIdTypeField = ({
    formController,
    texts,
    options = DocumentType
}) => {

    const inputTipoId = useId('tipoId');
    const { institucional } = texts;
    const { form } = institucional;

    // Identificador utilizado por React Hook Form para registrar el campo.
    const fieldName = 'tipoId';

    const {
        register,
        formState: { errors } } = formController

    return (
        <>
            <label
                htmlFor={inputTipoId}
                className="secondary-item"
            >
                <strong>{form?.tipoId?.label || 'Tipo de identificación*:'}</strong>
            </label>
            <select
                className="form-control focusable-secondary"
                id={inputTipoId}
                defaultValue=""
                {...register(fieldName, {
                    required: {
                        value: true,
                        message: form?.tipoId?.alert || 'Selecciona el tipo de documento',
                    },
                })}
            >
                <option hidden value="">
                    {form?.tipoId?.placeholder || 'Escoge el tipo de Identificación'}
                </option>
                {options.map((item) => (
                    <option key={item.id} value={item.text}>
                        {item.text}
                    </option>
                ))}
            </select>
            <FormMessage
                message={errors[fieldName]?.message}
                type="error" />
        </>
    );
}